import { ICountryOption } from "../services/countries.service";

export const stateLabelsDictionary: Record<string, string> = {
  NSW: "New South Wales",
  QLD: "Queensland",
  SA: "South Australia",
  TAS: "Tasmania",
  VIC: "Victoria",
  WA: "Western Australia",
  ACT: "Australian Capital Territory",
  NT: "Northern Territory"
};

export const stateOptions: ICountryOption[] = [
  'NSW',
  'QLD',
  'SA',
  'TAS',
  'VIC',
  'WA',
  'ACT',
  'NT'
].map((value) => ({
  value,
  label: value,
  countryCode: value,
  flagClass: `fi fi-${ value.toLowerCase() }`,
}));
